// src/shared/ui/PasswordInput.jsx — promoted from adai/components/ui/PasswordInput.jsx
import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import Input from "./Input.jsx";

const PasswordInput = forwardRef((props, ref) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative w-full">
      <Input type={show ? "text" : "password"} ref={ref} {...props} className="pr-12" />
      <button
        type="button"
        onClick={() => setShow(!show)}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-transparent border-0 p-0 text-slate-400 hover:text-slate-600 transition-colors cursor-pointer"
      >
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
});

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
